import { createSlice } from "@reduxjs/toolkit";
import { DataPeriodoInactividad } from "interfaces/periodosinactividad/periodosInactividadInterface";

interface ReducerPeriodosInactividad {
  dataPeriodosInactividad: DataPeriodoInactividad | null;
  canExceute: boolean;
}
export const periodosInactividadSlice = createSlice({
  name: "periodosInactividad",
  initialState: {
    dataPeriodosInactividad: null,
    canExceute: false,
  } as ReducerPeriodosInactividad,
  reducers: {
    onLoadPeriodosInactividad: (state, { payload }) => {
      state.dataPeriodosInactividad = payload;
    },
    onLoadCanExecute: (state, { payload }) => {
      state.canExceute = payload;
    },
  },
});

//actions creators are generated for each case reducer function
export const { onLoadPeriodosInactividad, onLoadCanExecute } =
  periodosInactividadSlice.actions;
